import React from "react";
import styles from './loadingSpinner.module.css';
import EsemieLoaderLogo from "../../../assets/icons/EsemieLoaderLogo"

const PageLoader: React.FC = () => {
    return (
      <section
        data-testid="page-1"
        className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50"
      >
        <div className={styles.spinner_box}>
          <div className={styles.spinner_card}>
            <EsemieLoaderLogo />
          </div>
          <div className={styles.spinner}></div>
        </div>
      </section>
    );
};

export default PageLoader;
